import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'

import SheetWrapper from '@/components/SheetWrapper/index'
import ScrollableList from '@/components/ScrollableList/index'

export default {
  components: {
    SheetWrapper,
    ScrollableList
  },
  methods: {
    ...mapActions({
      matchStatusAction: 'TRANSORM_MATCH_STATUS'
    }),
    ...mapActions('league', {
      fetchFixturesPageAction: 'FETCH_FIXTURES_PAGE'
    })
  },
  computed: {
    ...mapGetters({
      matchStatus: 'MATCH_STATUS_AVAILABILITY'
    }),
    ...mapGetters('league', {
      fixturesPage: 'FIXTURES_PAGE'
    })
  },
  data: () => ({
    baseUrl: '/app/league/fixtures',
    pageArr: null
  }),
  activated() {
    const timezone = moment.tz.guess()
    this.fetchFixturesPageAction({ timezone }).then(() => {
      this.pageArr = this.fixturesPage.data
    })
  }
}
